import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useMobileRoutes from "../hooks/useMobileRoutes";
import CookieConsentDescription from "./CookieConsentDescription";
import { hasNetlifeConsentCookie, writeNetlifeConsentCookie, } from "../../../../../apps/webshop/assets/Analytics/ConsentProviders/NetlifeConsentProvider";
// The mobile counterpart of the desktop banner in NetlifeConsentProvider.php.
// It is modal, so it covers no bottom bar or checkout button once answered.
const NetlifeConsentBanner = () => {
    const [t] = useTranslation();
    const routes = useMobileRoutes();
    const location = useLocation();
    const [open, setOpen] = useState(() => window.NTLF_CONFIG.netlifeConsentBanner === true &&
        !hasNetlifeConsentCookie());
    // Like desktop, the pages the banner links to show without it.
    const onLinkedPage = [
        routes.cookiesdescription.path,
        routes.privacypolicy.path,
    ].includes(location.pathname);
    const choose = (allowTracking) => {
        var _a;
        if (!((_a = window.epmsAnalytics) === null || _a === void 0 ? void 0 : _a.setNetlifeConsent(allowTracking))) {
            writeNetlifeConsentCookie(allowTracking);
        }
        setOpen(false);
    };
    return (React.createElement(Drawer, { anchor: "bottom", open: open && !onLinkedPage, 
        // Only a button press counts as an answer.
        onClose: () => { }, ModalProps: { disableEscapeKeyDown: true }, PaperProps: {
            role: "dialog",
            "aria-label": t("Cookie settings"),
            "data-testid": "netlife-consent-banner",
        } },
        React.createElement(Box, { sx: { p: 2, pb: "calc(16px + env(safe-area-inset-bottom))" } },
            React.createElement(Box, { component: "p", sx: { mt: 0 } },
                React.createElement(CookieConsentDescription, null)),
            React.createElement(Box, { sx: { display: "flex", flexDirection: "column", gap: 1 } },
                React.createElement(Button, { variant: "outlined", color: "primary", fullWidth: true, onClick: () => choose(false) }, t("Use only necessary cookies")),
                React.createElement(Button, { variant: "contained", color: "primary", fullWidth: true, onClick: () => choose(true) }, t("Allow all cookies"))))));
};
export default NetlifeConsentBanner;
